module.exports = __webpack_public_path__ + "static/media/radiance.6433da5e.png";